import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

interface GuestsFilteredBannerProps {
  searchTerm: string;
  onClear: () => void;
}

const GuestsFilteredBanner = ({
  searchTerm,
  onClear,
}: GuestsFilteredBannerProps) => (
  <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
    <Search className="h-12 w-12 text-gray-400 mx-auto mb-4" />

    <h3 className="text-gray-800 font-medium mb-2">
      No se encontraron resultados
    </h3>

    <p className="text-gray-600 text-sm mb-4">
      No hay huéspedes que coincidan con tu búsqueda "{searchTerm}".
    </p>

    <Button variant="outline" onClick={onClear}>
      Limpiar búsqueda
    </Button>
  </div>
);

export default GuestsFilteredBanner;
